import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/envelope': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M464 64c26.5 0 48 21.5 48 48v288c0 26.5-21.5 48-48 48h-416c-26.5 0-48-21.5-48-48v-288c0-26.5 21.5-48 48-48h416zM464 112h-416v40.8c22.4 18.3 58.2 46.7 134.6 106.5 16.8 13.2 50.2 45.1 73.4 44.7 23.2 0.4 56.6-31.5 73.4-44.7 76.4-59.8 112.2-88.2 134.6-106.5v-40.8zM48 400h416v-185.6c-22.9 18.3-55.4 43.9-104.9 82.7-22.5 17.7-60.3 55.2-103.1 54.9-42.9 0.2-81.2-37.8-103.1-55-49.5-38.8-82-64.4-104.9-82.6v185.6z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/envelope.js
// module id = 1725
// module chunks = 0